import { render } from "./BackModal.vue?vue&type=template&id=46b8cb28&scoped=true"
import script from "./BackModal.vue?vue&type=script&lang=js"
export * from "./BackModal.vue?vue&type=script&lang=js"

import "./BackModal.vue?vue&type=style&index=0&id=46b8cb28&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46b8cb28"]])

export default __exports__